<nav class="nailstyle-navbar">
  <div class="nailstyle-con">
    <div class="nailstyle-logo">
      <a href="/nail-style-blog"><img src="/images/nail-style-blog/homepage/nail style logo.svg"
          alt="Nail Style"/></a>
    </div>
    <ul class="nailstyle-nav">
      <!--START Nail Style Blog FASHION WEEK -->
      <!-- <li class="nailstyle-subnav" id="subnav" style="cursor: pointer;">
        <a href="/nail-style-blog/fashion-week">Fashion Week</a>
        <div class="nailstyle-subnav-content nailstyle-display-subnav">
          <a href="/nail-style-blog/fashion-week/fall-2023">2023 Fall Winter</a>
        </div>
      </li> -->
      <!--END Nail Style Blog FASHION WEEK -->
      <li class="nailstyle-subnav" id="subnav" style="cursor: pointer;">
        <a href="/colors/collections">Collections</a>
        <i class="fa-solid fa-angle-down" id="angleDown" style="color: #707070;">
        </i>
        <div class="nailstyle-subnav-content nailstyle-display-subnav">
          <a href="/nail-style-blog/eat-pray-polish">Eat, Pray, Polish</a>
          <a href="/nail-style-blog/mix-and-match">Mix & Match</a>
          <a href="/nail-style-blog/spring-fling">Spring Fling</a>
          <a href="/nail-style-blog/chart-topping">Chart-Topping</a>
          <a href="/nail-style-blog/note-from-danny">Note From Danny</a>
        </div>
      </li>
      <!-- <li class="nailstyle-subnav" id="subnav" style="cursor: pointer;">
        <a href="/collections/lace-is-more">Competitions</a>
        <i class="fa-solid fa-angle-down" id="angleDown" style="color: #707070;"></i>
        <div class="nailstyle-subnav-content nailstyle-display-subnav">
          <a href="/nail-style-blog/competitive-edge">A Competitive Edge</a>
        </div>
      </li> -->

      <li class="nailstyle-subnav" id="subnav" style="cursor: pointer;">
        <a href="#">Celeb Nails</a>
        <i class="fa-solid fa-angle-down" id="angleDown" style="color: #707070;"></i>
        <div class="nailstyle-subnav-content nailstyle-display-subnav">
          <a href="/nail-style-blog/spring-celeb-roundup">Spring Celeb Roundup</a>
        </div>
      </li>
      <li class="nailstyle-subnav" id="subnav" style="cursor: pointer;">
        <a href="#">Lifestyle</a>
        <i class="fa-solid fa-angle-down" id="angleDown" style="color: #707070;"></i>
        <div class="nailstyle-subnav-content nailstyle-display-subnav">
          <!-- <a href="/nail-style-blog/nail-your-festival-look">Nail Your Festival Look</a> -->
          <a href="/nail-style-blog/mood-matching-pedicures">Mood Matching Pedicures</a>
          <a href="/nail-style-blog/spring-spritzer">Spring Spritzers</a>
          <a href="/nail-style-blog/spring-into-radiance">Spring Into Radiance</a>
          <a href="/nail-style-blog/herb-appeal">Herb Appeal</a>
          <a href="/nail-style-blog/know-your-nude">Know Your Nude</a>
          <a href="/nail-style-blog/the-power-of-pastels">The Power Of Pastels</a>
          <a href="/nail-style-blog/the-beat-goes-on">The Beat Goes On</a>
          <a href="/nail-style-blog/gratitude-unboxed">Gratitude Unboxed</a>
          <a href="/nail-style-blog/nail-your-gift-list">Nail Your Gift List</a>
          <a href="/nail-style-blog/giving-thanks">Giving Thanks</a>
          <a href="/nail-style-blog/backstage-beauty">Backstage Beauty</a>
          <a href="/nail-style-blog/holiday-hues">Holiday Hues</a>
          <a href="/nail-style-blog/trend-alert-solid-cream-gels">Trend Alert: Solid Cream Gels</a>
          <a href="/nail-style-blog/fall-fashion-forecast">Fall Fashion Forecast</a>
          <a href="/nail-style-blog/poolside-reads">Poolside Reads</a>
          <a href="/nail-style-blog/five-must-have-shoes-for-summer">5 Must-Have Shoes For Summer</a>
          <a href="/nail-style-blog/sun-kissed-beauty">Sun-Kissed Beauty</a>
          <a href="/nail-style-blog/bridal-nail-prep">Bridal Nail Prep</a>
          <a href="/nail-style-blog/happy-anniversary">Happy Anniversary, Gelish!</a>
          <a href="/nail-style-blog/posh-prom">Posh Prom</a>
          <a href="/nail-style-blog/blooming-beginnings">Blooming Beginnings</a>
          <a href="/nail-style-blog/six-spring-fashion-musts">6 Spring Fashion Musts</a>
          <a href="/nail-style-blog/give-some-lip">Give Some Lip</a>
          <a href="/nail-style-blog/color-me-stylish">Color Me Stylish</a>
          <a href="/nail-style-blog/new-years-resolution">New Years Resolution</a>
          <a href="/nail-style-blog/cheers">Cheers!</a>
          <a href="/nail-style-blog/sugar-spice-and-everything-iced">Sugar, Spice and Everything Iced</a>
          <a href="/nail-style-blog/color-quiz">Color Quiz</a>
          <a href="/nail-style-blog/behind-the-scenes">Behind The Scenes</a>
          <a href="/nail-style-blog/blooming-201">Blooming 201</a>
          <a href="/nail-style-blog/trend-alert-90s-makeup-is-back">Trend Alert:'90s Makeup Is Back!</a>
          <a href="/nail-style-blog/say-nailfie">Say Nailfie!</a>
          <a href="/nail-style-blog/that-is-a-wrap">That's A Wrap!</a>
          <a href="/nail-style-blog/the-season-for-giving">Season For Giving</a>
          <a href="/nail-style-blog/head-to-toe">Head To Toe</a>
          <a href="/nail-style-blog/how-to-plan">How To Plan</a>
          <a href="/nail-style-blog/platinum-vinyl">Platinum &amp; Vinyl</a>
        </div>
      </li>
      <li class="nailstyle-subnav" id="subnav" style="cursor: pointer;">
        <a href="#">Wellness</a>
        <i class="fa-solid fa-angle-down" id="angleDown" style="color: #707070;"></i>
        <div class="nailstyle-subnav-content nailstyle-display-subnav">
          <a href="/nail-style-blog/fitness-made-simple">Fitness Made Simple</a>
          <a href="/nail-style-blog/the-beat-goes-on">The Beat Goes On</a>
          <a href="/nail-style-blog/winter-hand-rescue">Winter Hand Rescue</a>
          <a href="/nail-style-blog/healthy-eating-during-the-holidays">Healthy Eating During The Holidays</a>
          <a href="/nail-style-blog/seasonal-skincare-switch-up">Seasonal Skincare Switch-Up</a>
          <a href="/nail-style-blog/simple-stretches-for-back-health">Simple Stretches For Back Health</a>
          <a href="/nail-style-blog/h20-glow">H2O Glow</a>
          <a href="/nail-style-blog/tips-for-toenail-health">Tips For Toenail Health</a>
          <a href="/nail-style-blog/eye-on-ingredients-nourish">Eye On Ingredients: Nourish</a>
          <a href="/nail-style-blog/reviving-retail">Reviving Retail</a>
          <a href="/nail-style-blog/chill-proof-your-skin">Chill-Proof Your Skin</a>
          <a href="/nail-style-blog/spooky-chic">Spooky Chic</a>
          <a href="/nail-style-blog/sip-and-stir">Sip &amp; Stir</a>
          <a href="/nail-style-blog/fall-fashion-preview">Fall Fashion Preview</a>
          <a href="/nail-style-blog/self-care-in-the-digital-age">Self-Care In The Digital Age</a>
          <a href="/nail-style-blog/spotlight-on-2">Spotlight On</a>
          <a href="/nail-style-blog/six-ways-to-exercise-this-fall">6 Ways To Exercise This Fall</a>
          <a href="/nail-style-blog/get-glowing-summer-skin">Get Glowing Summer Skin</a>
          <a href="/nail-style-blog/satisfying-snacks">Satisfying Snacks</a>
          <a href="/nail-style-blog/summer-sips">Summer Sips</a>
          <a href="/nail-style-blog/your-essential-summer-playlist">Your Essential Summer Playlist</a>
          <a href="/nail-style-blog/ways-to-stay-healthy">Ways To Stay Healthy</a>
          <a href="/nail-style-blog/exercises-to-do">10 Exercises To Do</a>
          <a href="/nail-style-blog/festive-recipes-holiday-season">Festive Recipes</a>
        </div>
      </li>
      <li class="nailstyle-subnav" id="subnav" style="cursor: pointer;">
        <a href="#">Tech Talk</a>
        <i class="fa-solid fa-angle-down" id="angleDown" style="color: #707070;"></i>
        <div class="nailstyle-subnav-content nailstyle-display-subnav">
          <a href="/nail-style-blog/springs-soft-focus">Spring's Soft Focus</a>
          <a href="/nail-style-blog/spring-fashion-tips">Spring Fashion Tips</a>
          <a href="/nail-style-blog/naked-nails">Naked Nails</a>
          <a href="/nail-style-blog/simple-pleasures">Simple Pleasures</a>
          <a href="/nail-style-blog/black-friday-buys">Black Friday Buys</a>
          <a href="/nail-style-blog/go-it-alone">Go It Alone</a>
          <a href="/nail-style-blog/sustainable-style">Sustainable Style</a>
          <a href="/nail-style-blog/innovative-inventions">Innovative Inventions</a>
          <a href="/nail-style-blog/crystal-celebration">Crystal Celebration</a>
          <a href="/nail-style-blog/stuck-on-you">Stuck On You</a>
          <a href="/nail-style-blog/whats-your-summer-nail-color">What's Your Summer Nail Color?</a>
          <a href="/nail-style-blog/stick-it-to-me">Stick It To Me</a>
          <a href="/nail-style-blog/sparkle-and-shine">Sparkle &amp; Shine</a>
          <a href="/nail-style-blog/career-boost">Career Boost</a>
          <a href="/nail-style-blog/light-it-up">Light It Up</a>
          <a href="/nail-style-blog/dip-tricks">Dip Tricks</a>
          <a href="/nail-style-blog/swipe-right">Swipe Right</a>
          <a href="/nail-style-blog/over-the-top">Over The Top</a>
          <a href="/nail-style-blog/glittery-and-bright">All is Glittery &amp; Bright</a>
          <a href="/nail-style-blog/benefits-of-gelish-vortex">Benefits of Gelish VORTEX</a>
          <a href="/nail-style-blog/technology-in-the-salon">Technology in the Salon</a>
          <a href="/nail-style-blog/flex-your-power">Flex Your Power</a>
          <a href="/nail-style-blog/xpress-yourself">Xpress Yourself</a>
        </div>
      </li>
      <li class="nailstyle-subnav" id="subnav" style="cursor: pointer;">
        <a href="#">Nail Tech</a>
        <i class="fa-solid fa-angle-down" id="angleDown" style="color: #707070;"></i>
        <div class="nailstyle-subnav-content nailstyle-display-subnav">
          <a href="/nail-style-blog/spotlight-on-7">Spotlight On</a>
          <a href="/nail-style-blog/workspace-refresh">Workspace Refresh</a>
          <a href="/nail-style-blog/coworker-confrontations">Coworker Confrontations</a>
          <a href="/nail-style-blog/secrets-of-my-success">Secrets of My Success</a>
          <a href="/nail-style-blog/spotlight-on-6">Spotlight On...</a>
          <a href="/nail-style-blog/fall-layers">Fall Layers</a>
          <a href="/nail-style-blog/magnetic-appeal">Magnetic Appeal</a>
          <a href="/nail-style-blog/flash-back">Flash Back</a>
          <a href="/nail-style-blog/spotlight-on-5">Spotlight On MaeLing</a>
          <a href="/nail-style-blog/client-consults">Client Consults</a>
          <a href="/nail-style-blog/spotlight-on-4">Spotlight On Antony</a>
          <a href="/nail-style-blog/scratch-magazine">Scratch Magazine</a>
          <a href="/nail-style-blog/secrets-of-trade-show-success">Secrets Of Trade Show Success</a>
          <a href="/nail-style-blog/in-full-bloom">In Full Bloom</a>
          <a href="/nail-style-blog/spotlight-on-3">Spotlight On Nancy</a>
          <a href="/nail-style-blog/competitive-edge">A Competitive Edge</a>
          <a href="/nail-style-blog/tips-and-tricks">Tips &amp; Tricks</a>
          <a href="/nail-style-blog/setting-the-gold-standard">Setting The Gold</a>
        </div>
      </li>
      <li class="nailstyle-subnav" id="subnav" style="cursor: pointer;">
        <a href="/nail-style-blog/fashion-week">Fashion Week</a>
        <i class="fa-solid fa-angle-down" id="angleDown" style="color: #707070;"></i>
        <div class="nailstyle-subnav-content nailstyle-display-subnav">
          <a href="/nail-style-blog/fashion-week/2023-fall-winter">Fall/Winter 2023</a>
          <a href="/nail-style-blog/fashion-week/2022-spring-summer">Spring/Summer 2022</a>
          <a href="/nail-style-blog/fashion-week/2020-fall-winter">Fall/Winter 2020</a>
          <a href="/nail-style-blog/fashion-week/2020-spring-summer">Spring/Summer 2020</a>
          <a href="/nail-style-blog/fashion-week/2019-fall-winter">Fall/Winter 2019</a>
          <a href="/nail-style-blog/fashion-week/2019-spring-summer">Spring/Summer 2019</a>
          <a href="/nail-style-blog/fashion-week/2018-fall-winter">Fall/Winter 2018</a>
          <a href="/nail-style-blog/fashion-week/2018-spring-summer">Spring/Summer 2018</a>
          <a href="/nail-style-blog/fashion-week/2017-spring-summer">Spring/Summer 2017</a>
          <a href="/nail-style-blog/fashion-week/2016-fall-winter">Fall/Winter 2016</a>
          <a href="/nail-style-blog/fashion-week/2016-spring-summer">Spring/Summer 2016</a>
          <a href="/nail-style-blog/fashion-week/2015-fall-winter">Fall/Winter 2015</a>
          <a href="/nail-style-blog/fashion-week/2015-spring-summer">Spring Summer 2015</a>
          <a href="/nail-style-blog/fashion-week/2014-fall-winter">Fall/Winter 2014</a>
          <a href="/nail-style-blog/fashion-week/2014-spring-summer">Spring/Summer 2014</a>
        </div>
      </li>
      <li class="nailstyle-subnav" id="subnav" style="cursor: pointer;">
        <a href="#">Previous magazines</a>
        <i class="fa-solid fa-angle-down" id="angleDown" style="color: #707070;"></i>
        <div class="nailstyle-subnav-content nailstyle-display-subnav">
          <a href="https://o.gelish.com/nail-style-new/summer-2022">summer 2022</a>
          <a href="https://o.gelish.com/nail-style-new/winter-2019">winter 2019</a>
          <div class="submenu-previous-issues">
            <a href="#" style="background-color: #eee;">Previous Issues<i
                class="fa-solid fa-angle-down"
                id="angleDown"
                style="color: #707070; margin-left:10px; font-size:0.625em;"></i></a>
            <div class="submenu-previous-items">
              <a href="https://o.gelish.com/nail-style-new/fall-2019">fall 2019</a>
              <a href="https://o.gelish.com/nail-style-new/summer-2019">summer 2019</a>
              <a href="https://o.gelish.com/nail-style-new/spring-2019">spring 2019</a>
              <a href="https://o.gelish.com/nail-style-new/holiday-winter-2018">holiday/winter 2018</a>
              <a href="https://o.gelish.com/nail-style-new/fall-2018">fall 2018 issue</a>
              <a href="https://o.gelish.com/nail-style-new/summer-2018">summer 2018 issue</a>
              <a href="https://o.gelish.com/nail-style-new/spring-2018">spring 2018 issue</a>
              <a href="https://o.gelish.com/nail-style-new/winter-2017">winter 2017 issue</a>
              <a href="https://o.gelish.com/nail-style-new/fall-2017">fall 2017</a>
              <a href="https://o.gelish.com/nail-style/16">summer 2017</a>
              <a href="https://o.gelish.com/nail-style/15">spring 2017</a>
              <a href="https://o.gelish.com/nail-style/14">winter 2016</a>
              <a href="https://o.gelish.com/nail-style/13">fall 2016</a>
              <a href="https://o.gelish.com/nail-style/12">summer 2016</a>
              <a href="https://o.gelish.com/nail-style/11">spring 2016</a>
              <a href="https://o.gelish.com/nail-style/10">winter 2015</a>
              <a href="https://o.gelish.com/nail-style/9">fall 2015</a>
              <a href="https://o.gelish.com/nail-style/8">summer 2015</a>
              <a href="https://o.gelish.com/nail-style/7">spring 2015</a>
              <a href="https://o.gelish.com/nail-style/6">winter 2014</a>
              <a href="https://o.gelish.com/nail-style/5">fall 2014</a>
              <a href="https://o.gelish.com/nail-style/4">summer 2014</a>
              <a href="https://o.gelish.com/nail-style/3">spring 2014</a>
              <a href="https://o.gelish.com/nail-style/2">winter 2013</a>
              <a href="https://o.gelish.com/nail-style/1">fall 2013</a>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</nav>

<style>
  .nailstyle-con {
    display: flex;
    flex-direction: column;
    width: 100%;
    /* max-width: 960px; */
    margin: 0 auto;
    justify-content: center;
    align-items: center;
    padding: 17px 0;
    line-height: 2em;
  }
  .nailstyle-navbar {
    background: #f7f7f7;
    color: #000000;
    height: auto;
    text-transform: uppercase;
    position: relative;
    /* top: auto; */
    padding-top: 45px;
  }
  .nailstyle-logo {
    display: flex;
    width: 100%;
    position: relative;
    justify-content: center;
    margin: 10px 0;
  }
  .nailstyle-navbar a {
    color: #000000;
    text-decoration: none;
    /* font-size: 1.25em; */
    padding: 0 7px;
    /* font-family: "HCo Gotham SSm", Arial, Helvetica, sans-serif; */
    font-size: 0.875em;
    font-family: "gotham-book";
  }
  .nailstyle-navbar a:hover {
    color: #333;
  }
  .nailstyle-navbar ul {
    display: flex;
    gap: 1rem;
    list-style-type: none;
    padding: 0;
    margin: 0;
    width: 100%;
    /* max-width: 960px; */
    justify-content: center;
    z-index: 1;
  }

  /* Previous Magazines */
  .nailstyle-subnav-content {
    position: absolute;
    width: 200px;
    background-color: #f7f7f7;
  }
  .nailstyle-display-subnav {
    display: none;
  }
  .nailstyle-subnav-content a {
    text-align: left;
    display: block;
    color: black;
    text-decoration: none;
    line-height: 1.4rem;
  }
  .nailstyle-subnav-content a:hover {
    background-color: #eee;
  }
  .nailstyle-subnav:hover .nailstyle-subnav-content {
    display: block;
  }

  /* Previous Issues */
  .submenu-previous-items {
    display: none;
  }
  .submenu-previous-issues:hover .submenu-previous-items {
    display: block;
  }

  .footer-banner a img {
    border: none;
    vertical-align: top;
  }

  @media only screen and (max-width: 995px) {
    .nailstyle-logo {
      text-align: center;
      display: inline-block;
      padding: 15px 0;
    }

    .nailstyle-navbar ul {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0;
    }
  }
</style>
